import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: {'foreignReport': _ctx.state.lang==='en' || _ctx.state.lang==='ru'}
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.state.renderComponent)))
  ], 2))
}